import Vue from 'vue'
import Router from 'vue-router'
//招商大脑（各版本通用）的链接 
import tagsearch from '@/components/common-list/tagsearch.vue' //标签搜索页 
import targetEnterprise from '@/components/common-list/targetEnterprise.vue' //标签搜索页 
import opportunities from '@/components/common-list/wholeChainlist.vue' //产业机会(全国图谱) 
import concernedEn from '@/components/common-list/concernedEn.vue' //龙头企业 (产业链招商线索) 23.12.4废置，已由recommendation 替换
import investmentInstitutions from '@/components/common-list/investmentInstitutions.vue' //投资机构

//按照湖南驻粤办要求更改页面
import findProjects from '@/components/project/findProjects.vue' //找项目
import projectList from '@/components/project/projectList.vue' //已录项目列表
import evaluationProject from '@/components/project/evaluationProject.vue' //评项目
import pushProject from '@/components/project/pushProject.vue' //推项目
import implementProject from '@/components/project/implementProject.vue' //落项目
import publicProject from '@/components/project/publicProject.vue' //落项目


import workbenchEnterpriseDetails from '@/components/detail/workbenchEnterpriseDetails.vue' //宏观背景 
import freeTips from "@/components/common-list/freeTips.vue" //免费用户提示
import homePage from "@/components/home-page/homePage.vue" //招商大脑首页


import focusenterprises from "@/components/common-list/focusenterprises.vue" //关注企业
import test from "@/components/common-list/test.vue" //关注企业

import enterpriseList from "@/components/common-list/enterpriseList.vue" //龙头上市优质创新企业集合列表
import totalenterprises from "@/components/common-list/totalEnterprises.vue" //全部内资企业-
import totalSearch from "@/components/common-list/totalSearch.vue" //全部内资企业-
import localChainList from "@/components/common-list/localChainList.vue" //当地图谱
import allchain from '@/components/common-list/allchain.vue' //产业链首页（所有产业链 ）


//招商大脑简易版链接
import trade from "@/components/touzi/trade.vue" //行业库
import industryLibrary from "@/components/touzi/industryLibrary.vue" //行业库、市场规模、竞争格局
//投资大脑 研究大脑 


import report from "@/components/common-list/report.vue" //研究报告，只有免登陆的免费版才有
import enterprisesCityRelation from "@/components/common-list/enterprisesCityRelation.vue" //企业城市关系（作战地图触达线索 ）

import userlogin from '@/components/login/user-login.vue' //登录 
import findpassword from '@/components/login/findpassword.vue' //找回密码
//用户页面 
import baseinformation from '@/components/user/baseInformation.vue' //基础信息
import userFocus from '@/components/user/userFocus.vue' //关注领域 
import chainNotions from '@/components/user/chainNotion.vue' //关注领域 -当地图谱引用
import calculatorresult from '@/components/user/calculatorResult.vue' //关注领域 
import servicebook from '@/components/user/serviceBook.vue' //关注领域 
import followuprecord from '@/components/user/followuprecord.vue' //跟进纪录
import todolist from '@/components/user/todolist.vue' //跟进纪录
//工作台
import projectmanagement from '@/components/user/projectmanagement.vue' //项目管理 
import statisticalAnalysis from '@/components/user/statisticalAnalysis.vue' //统计分析  
import systemManagement from '@/components/user/systemManagement.vue' //系统管理 

import editPassword from '@/components/user/editPassword.vue' //关注领域 
Vue.use(Router)

const router = new Router({
	// mode: "history",
	mode: "hash",
	routes: [
	//招商大脑简易版
	{

		path: '/workbenchEnterpriseDetails',
		name: 'workbenchEnterpriseDetails',
		component: workbenchEnterpriseDetails
	},
	//投资大脑 研究大脑 
	{
		path: '/industryLibrary',
		name: 'industryLibrary',
		component: industryLibrary
	},
	{
		path: '/trade',
		name: 'trade',
		component: trade
	},
	
	{
		path: '/report',
		name: 'report',
		component: report
	},
	//首页 
	{
		path: '/',
		name: 'userlogin',
		component: userlogin,
		// redirect:"/enterpriseList"
	},
	 
	//政府端
	{
		path: '/industrial-opportunities',
		name: 'industrial-opportunities',
		component: opportunities
	},
	{
		path: '/concerned-enterprises',
		name: 'concerned-enterprises',
		component: concernedEn,
	},
	{
		path: '/investment-institutions',
		name: 'investmentInstitutions',
		component: investmentInstitutions,
	},
	{
		path: '/projectList',
		name: 'projectList',
		component: projectList,
	},
	{
		path: '/evaluationProject',
		name: 'evaluationProject',
		component: evaluationProject,
	},
	{
		path: '/pushProject',
		name: 'pushProject',
		component: pushProject,
	},
	{
		path: '/implementProject',
		name: 'implementProject',
		component: implementProject,
	},
	{
		path: '/publicProject',
		name: 'publicProject',
		component: publicProject,
	},
	
	{
		path: '/findProjects',
		name: 'findProjects',
		component: findProjects,
	},
	
	{
		path: '/free-tips',
		name: 'freeTips',
		component: freeTips
	},
	{
		path: '/homePage',
		name: 'homePage',
		component: homePage
	},

	{
		path: '/enterpriseTag',
		name: 'enterpriseTag',
		component: tagsearch,
	},
	{
		path: '/targetEnterprise',
		name: 'targetEnterprise',
		component: targetEnterprise,
	},
	{
		path: '/enterpriseList',
		name: 'enterpriseList',
		component: enterpriseList,
	},
	{
		path: '/totalEnterprises',
		name: 'totalenterprises',
		component: totalenterprises,
	},
	{
		path: '/totalSearch',
		name: 'totalSearch',
		component: totalSearch,
	},

	{
		path: '/localChainList',
		name: 'localChainList',
		component: localChainList,
	},
	{
		path: '/enterprisesCityRelation',
		name: 'enterprisesCityRelation',
		component: enterprisesCityRelation,
	},
	{
		path: '/focusenterprises',
		name: 'focusenterprises',
		component: focusenterprises,
	},
	{
		path: '/test',
		name: 'test',
		component: test,
	},
	
	{
		path: '/projectmanagement',
		name: 'projectmanagement',
		component: projectmanagement,
	},
	{
		path: '/todolist',
		name: 'todolist',
		component: todolist,
	},
	{
		path: '/followuprecord',
		name: 'followuprecord',
		component: followuprecord,
	},
	{
		path: '/statisticalAnalysis',
		name: 'statisticalAnalysis',
		component: statisticalAnalysis,
	},
	{
		path: '/systemManagement',
		name: 'systemManagement',
		component: systemManagement,
	},
	{
		path: '/allchain',
		name: 'allchain',
		component: allchain,
	},
	//用户中心-我的页面
	{
		path: '/baseinformation',
		name: 'baseinformation',
		component: baseinformation
	},
	{
		path: '/servicebook',
		name: 'servicebook',
		component: servicebook
	},
	{
		path: '/userFocus',
		name: 'userFocus',
		component: userFocus
	},
	{
		path: '/chainNotions',
		name: 'chainNotions',
		component: chainNotions
	},
	{
		path: '/calculatorresult',
		name: 'calculatorresult',
		component: calculatorresult
	},
	{
		path: '/editPassword',
		name: 'editPassword',
		component: editPassword
	},
	
	{
		path: '/user-login',
		name: 'user-login',
		component: userlogin
	},
	{
		path: '/findpassword',
		name: 'findPassword',
		component: findpassword
	},

		// {
		//   path: '/chainDetail',
		//   name: 'chaindetail',
		//   component: chaindetail
		// }, 
	]
})

var clasnum = 1;
router.beforeEach((to, from, next) => {
	// chrome
	document.body.scrollTop = 0
	// firefox
	document.documentElement.scrollTop = 0
	// safari
	window.pageYOffset = 0
	next()
});

// 解决重复点击导航时，控制台出现报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default router;
